import PropTypes from 'prop-types'
import React from 'react'
import { CSSTransition } from 'react-transition-group'
import { getMergedClassNames } from '../../utils/HTMLutils'
import Collapse from '../collapse/Collapse'
import IconButton from '../iconButton/IconButton'
import Row from '../row/Row'
import './HeaderSearchField.scss'
const rootClassName = 'component-header-search-field'

export default function HeaderSearchField(props) {
  const inputProps = {
    ...props.inputProps
  }
  delete inputProps.rightObject
  delete inputProps.loading

  return (
    <div className={rootClassName}>
      <div
        className={getMergedClassNames([
          `${rootClassName}-inline-input`,
          props.loading ? 'loading' : '',
          props.disabled || (props.inputProps && props.inputProps.disabled)
            ? 'disabled'
            : ''
        ])}
      >
        <div className={`${rootClassName}-container-input`}>
          <input
            {...inputProps}
            disabled={
              props.disabled || (props.inputProps && props.inputProps.disabled)
            }
            className={getMergedClassNames([
              `${rootClassName}-input`,
              `panel-${props.panelOpened ? 'opened' : 'closed'}`,
              props.inputProps && props.inputProps.className
                ? props.inputProps.className
                : '',
              props.loading ? 'loading' : ''
            ])}
          />
        </div>
        <div className={`${rootClassName}-focus-border`} />
        <div className={`${rootClassName}-loading-border`} />
      </div>
      <div className={`${rootClassName}-right-icon`}>
        <IconButton
          icon={props.rightIcon}
          onClick={props.onRightObjectClick}
          disabled={
            props.disabled || (props.inputProps && props.inputProps.disabled)
          }
        />
      </div>
      <div
        className={getMergedClassNames([
          `${rootClassName}-panel`,
          `${props.panelOpened ? 'opened' : 'closed'}`
        ])}
      >
        <Collapse opened={props.panelOpened}>
          <div className={`${rootClassName}-content`}>
            <Row>Botão</Row>
            <Row>Linhas de Resultado que ainda estão à ser priorizados!</Row>
            <Row>Linhas de Resultado que ainda estão à ser priorizados!</Row>
            <Row>Linhas de Resultado que ainda estão à ser priorizados!</Row>
            <Row>Linhas de Resultado que ainda estão à ser priorizados!</Row>
          </div>
        </Collapse>
      </div>
      <CSSTransition
        in={props.panelOpened}
        classNames={`${rootClassName}-mask-fade`}
        timeout={300}
        unmountOnExit
      >
        <div
          className={`${rootClassName}-mask`}
          onClick={() => {
            if (typeof props.onMaskClick === 'function') {
              props.onMaskClick()
            }
          }}
        />
      </CSSTransition>
    </div>
  )
}

HeaderSearchField.propTypes = {
  inputProps: PropTypes.shape({
    value: PropTypes.any,
    onChange: PropTypes.func,
    disabled: PropTypes.bool
  }),
  results: PropTypes.arrayOf(PropTypes.object),
  panelOpened: PropTypes.bool,
  rightIcon: PropTypes.object,
  onRightObjectClick: PropTypes.func,
  onMaskClick: PropTypes.func,
  loading: PropTypes.bool,
  disabled: PropTypes.bool
}

HeaderSearchField.defaultProps = {
  onRightObjectClick: () => {}
}
